export function getEnvironment(hostname = '') {
  const host = typeof hostname === 'string' ? hostname.toLowerCase().trim() : ''
  const storedColor = sessionStorage.getItem('stackColor')
  const colorSuffix = storedColor
    ? ` ${storedColor.charAt(0).toUpperCase()}${storedColor.slice(1)}`
    : ''

  if (!host) {
    return 'local'
  }

  if (host.includes('localhost')) {
    return 'local'
  }

  // Order matters — combined checks before individual
  if (host.includes('dev-testing')) {
    return 'dev-testing'
  }

  if (host.includes('dev')) {
    return 'dev'
  }

  if (host.includes('blue') && host.includes('staging')) {
    return 'Staging Blue'
  }

  if (host.includes('green') && host.includes('staging')) {
    return 'Staging Green'
  }

  // GA unified hostname: augment with backend-sourced color when available
  if (host.includes('staging')) {
    return `Staging${colorSuffix}` || 'staging'
  }

  if (host.includes('blue')) {
    return 'Prod Blue'
  }

  if (host.includes('green')) {
    return 'Prod Green'
  }

  return `Prod${colorSuffix}` || 'production'
}
